<div class="row">
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Filing Date</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{data?.filingDate | date: 'MM/dd/yyyy'}}</div>
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Applicant Name</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{  getApplicantName() }}</div>
  </div>
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Qualification Type</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{  getQualificationType() }}</div>
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Date of Birth</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{  data?.birthDate | date: 'MM/dd/yyyy'  }}
    </div>
  </div>
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">FEIN</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{  data?.fein | mask:'00-0000000'}}</div>
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Email</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{  data?.contactEmail }}</div>
  </div>
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Entity Control #</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{ data?.entityControlNumber }}</div>
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Phone</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{ data?.contactPhone | mask: '(000)000-0000' }}</div>
  </div>
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Business Entity Name</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{ data?.filingEntityName }}</div>
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Last 4 SSN</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{ data?.lastFourSocialSecurityNumber }}</div>
  </div>
  <div class="bottom-line"></div>
  
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Mailing Address</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{getMailingAddress()}}</div>
    <div class="col-lg-3 col-md-3 col-sm-6" style="text-align: right;">Physical Address</div>
    <div class="col-lg-3 col-md-3 col-sm-6">{{ getPhysicalAddress() }}</div>
  </div>
  <div class="bottom-line"></div>
  <div class="row">
    <div class="col-lg-9 col-md-9 col-sm-9" style="text-align: start;">{{licenseContractorsText}}</div>
    <div class="col-lg-3 col-md-3 col-sm-3">{{ CsPLicense == null ? 'Yes' : 'No'}}</div> 
   </div>
  <div class="row">
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">State License #</div>
    <div class="col-lg-2 col-md-3 col-sm-6">{{ data?.stateLicense?.licenseNumber }}</div>
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">Expiration Date</div>
    <div class="col-lg-2 col-md-3 col-sm-6">{{ data?.stateLicense?.licenseExpirationDate | date: 'MM/dd/yyyy' }}</div>
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">Contractor Service Provider #</div>
    <div class="col-lg-2 col-md-3 col-sm-6">{{ data?.cspLicense?.licenseNumber }}</div>
  </div>
  <div class="bottom-line"></div>
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-9" style="text-align: start;">County Business License</div>
  </div>
  <div class="row">
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">County License #</div>
    <div class="col-lg-2 col-md-3 col-sm-6">{{data?.countyLicense?.licenseNumber }}</div>
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">Expiration Date</div>
    <div class="col-lg-2 col-md-3 col-sm-6"> {{ data?.countyLicense?.licenseExpirationDate | date: 'MM/dd/yyyy' }}</div>
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">County</div>
    <div class="col-lg-2 col-md-3 col-sm-6">{{ data?.countyLicense?.county?.name}}</div>
  </div>
  <div class="bottom-line"></div>
  <div class="row">
    <div class="col-lg-3 col-md-3 col-sm-9" style="text-align: start;">City Business License</div>
  </div>
  <div class="row">
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">City License #</div>
    <div class="col-lg-2 col-md-3 col-sm-6">{{ data?.cityLicense?.licenseNumber }}</div>
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">Expiration Date</div>
    <div class="col-lg-2 col-md-3 col-sm-6">{{ data?.cityLicense?.licenseExpirationDate | date: 'MM/dd/yyyy' }}</div>
    <div class="col-lg-2 col-md-3 col-sm-6" style="text-align: right;">City</div>
    <div class="col-lg-2 col-md-3 col-sm-6">{{ data?.cityLicense?.city?.name }}</div>
  </div>
  <div class="bottom-line"></div>
  <form class="qualification-tab-form" [formGroup]="ConfirmationTab">
    <div *ngIf="regApFtype.includes(FillingType)" fxLayout="row" fxLayoutGap="50px">
      <mat-checkbox [required]="IsExternal" [ngClass]="ConfirmationTab.controls['registeredApplicant'].invalid ? 'errorMsg' : ''" formControlName="registeredApplicant" class="mailingAddress">{{registeredApplicantCheckBox}}</mat-checkbox>
    </div>
    <div *ngIf="doHvInjutyFtype.includes(FillingType)" fxLayout="row" fxLayoutGap="50px">
      <mat-checkbox [checked]="injuryMode" [required]="IsExternal" [ngClass]="injuryMode == null ? 'errorMsg' : ''" (change)="onCheck(true, $event)" class="mailingAddress">{{yesHaveInjuryCheckBox}}</mat-checkbox>
    </div>
    <div *ngIf="doHvInjutyFtype.includes(FillingType)" fxLayout="row" fxLayoutGap="50px">
      <mat-checkbox [checked]="injuryMode != null && !injuryMode" [required]="IsExternal" [ngClass]="injuryMode == null ? 'errorMsg' : ''" (change)="onCheck(false, $event)" class="mailingAddress">{{dontHaveInjuryCheckBox}}</mat-checkbox>
    </div>
    <div class="bottom-line"></div>
  </form>
  